import { FieldTypes, timeSlotPicker, dateField } from 'drapcode-constant';

const moment = require('moment');
export const settingDates = [
  'MM/DD/YY',
  'MM-DD-YY',
  'MM/DD/YYYY',
  'MM-DD-YYYY',
  'DD-MM-YY',
  'DD/MM/YY',
  'DD-MM-YYYY',
  'DD/MM/YYYY',
  'YYYY-MM-DD',
  'YYYY/MM/DD',
  'YYYY-DD-MM',
  'YYYY/DD/MM',
];
const timePatterns = ['HH:mm', 'hh:mm a', 'HH:mm:ss', 'hh:mm:ss a'];
export const datePatterns = [
  ...settingDates,
  'MMMM Do YYYY, h:mm:ss a',
  'dddd',
  'MMM Do YY',
  'ddd, DD MMM YYYY',
  'Do MMM YYYY',
  'DD MMM YYYY',
  ...timePatterns,
  'LT',
  'LTS',
  'L',
  'l',
  'LL',
  'll',
  'LLL',
  'lll',
  'LLLL',
  'llll',
  'FROM_NOW',
  'X',
  'x',
];

const dateDifferencePatterns = [
  'years',
  'quarters',
  'months',
  'weeks',
  'days',
  'hours',
  'minutes',
  'seconds',
  'milliseconds',
  'years,months',
  'years,months,weeks',
  'years,months,weeks,days',
  'years,months,days',
  'years,months,days,hours',
  'months,weeks',
  'months,weeks,days',
  'months,days',
  'months,days,hours',
  'months,days,hours,minutes',
  'weeks,days',
  'weeks,days,hours',
  'weeks,days,hours,minutes',
  'days,hours',
  'days,hours,minutes',
  'days,hours,minutes,seconds',
  'hours,minutes',
  'hours,minutes,seconds',
  'hours,minutes,seconds,milliseconds',
  'minutes,seconds',
  'minutes,seconds,milliseconds',
  'seconds,milliseconds',
];

export const labelForDateDifference = (pattern) => {
  let exampleStr = 'i.e. : ';
  const patterns = pattern.split(',');
  patterns.forEach((item, i) => {
    exampleStr =
      exampleStr +
      `${i + 1} ${item.charAt(0).toUpperCase() + item.slice(1)}${
        i === patterns.length - 1 ? '' : ','
      } `;
  });
  return `${pattern} (${exampleStr})`;
};

export const lableForDatePatters = (pattern) => {
  switch (pattern) {
    case 'FROM_NOW':
      return `Time till now (i.e.: ${moment().fromNow()} , 3 days ago etc..)`;
    case 'X':
      return `X (Timestamp in Sec) (i.e.: ${moment().format('X')})`;
    case 'x':
      return `x (Timestamp in Millisec) (i.e.: ${moment().format('x')})`;
    default:
      return `${pattern} (i.e.: ${moment().format(pattern)})`;
  }
};

export const lableForUnixType = (type) => {
  switch (type) {
    case 'SEC':
      return 'Seconds (Timestamps is in Seconds)';
    case 'MILLISEC':
      return 'Milliseconds (Timestamps is in Milliseconds)';
  }
};

export const date_data = [
  {
    name: 'FORMAT_DATE',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'datentime',
        label: 'Args',
        value: '',
        hint: 'Choose field from collection',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'unixType',
        label: 'Timestamp Type',
        options: ['SEC', 'MILLISEC'],
        hint: 'Choose Unix Timestamp is in milliseconds or seconds',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'formatType',
        label: 'Format Type',
        options: datePatterns,
        hint: 'Choose pattern to format the date',
      },
    ],
    allowedTypes: [...dateField, FieldTypes.unix_timestamp.id, ...timeSlotPicker],
  },
  {
    name: 'DATE_DIFFERENCE',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'datentime1',
        label: 'Args',
        value: '',
        hint: 'Choose First field from collection',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'datentime2',
        label: 'Args',
        value: '',
        hint: 'Choose Second field from collection',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'formatType',
        label: 'Format Type',
        options: dateDifferencePatterns,
        hint: 'Choose pattern to format the date',
      },
    ],
    allowedTypes: ['date', 'createdAt', 'updatedAt'],
  },
  {
    name: 'DATE_ADD',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'datentime1',
        label: 'Args',
        value: '',
        hint: 'Choose First field from collection',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'unitToAdd',
        label: 'Value to add to date.',
        type: 'number',
        external: true,
        value: '',
        hint: 'Number of days/month/years to add',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'unitTypeToAdd',
        label: 'Value Type to Add.',
        options: ['years', 'months', 'weeks', 'days'],
        hint: 'Choose pattern to format the date',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'formatType',
        label: 'Format Type',
        options: datePatterns,
        hint: 'Choose pattern to format the date',
      },
    ],
    allowedTypes: ['date', 'createdAt', 'updatedAt'],
  },
];

// Date Operations
export const FORMAT_DATE = (formatType, datentime, unixType) => {
  const formatDateNTime =
    unixType && unixType === 'SEC' ? moment(datentime * 1000) : moment(datentime);
  if (formatType === 'FROM_NOW') {
    return formatDateNTime.fromNow();
  }
  return formatDateNTime.format(formatType);
};

export const DATE_DIFFERENCE = (formatType, datentime1, datentime2) => {
  let result = '';
  const firstDate = datentime1 === 'CURRENT_DATE_TIME' ? moment() : moment(datentime1);
  const secondDate = datentime2 === 'CURRENT_DATE_TIME' ? moment() : moment(datentime2);
  const patterns = formatType.split(',');
  patterns.forEach((format, i) => {
    const diff = firstDate.diff(secondDate, format);
    if (diff < 0) {
      firstDate.subtract(diff, format);
    } else {
      secondDate.add(diff, format);
    }
    result =
      result +
      `${Math.abs(diff)} ${format.charAt(0).toUpperCase() + format.slice(1)}${
        i === patterns.length - 1 ? '' : ','
      } `;
  });
  return result;
};

export const DATE_ADD = (datentime1, unitToAdd, unitTypeToAdd, formatType) => {
  return { datentime1, unitToAdd, unitTypeToAdd, formatType };
};
